import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import StoryPage from "../pages/StoryPage";
import BlogPage from "../pages/BlogPage";
import PressPage from "../pages/PressPage";
import Login from "../common/Login";
import PrivateUserRoute from "./PrivateUserRoute";
import QuestionAnswerForm from "../component/QuestionAnswerForm";
import SIgnUp from "../common/SIgnUp";
import Settings from "../common/Settings";
import ForgotPassword from "../common/ForgotPassword";
import VerifyOtp from "../common/VerifyOtp";
import SetPassword from "../common/SetPassword";

export const Routing = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/signup" element={<SIgnUp />} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route exact path="/verify-otp" element={<VerifyOtp />} />
        <Route exact path="/set-password" element={<SetPassword />} />
        <Route
          exact
          path="/"
          element={
            <PrivateUserRoute>
              <LandingPage />
            </PrivateUserRoute>
          }
        />
        <Route
          exact
          path="/story"
          element={
            <PrivateUserRoute>
              <QuestionAnswerForm/>
            </PrivateUserRoute>
          }
        />

         
        <Route
          exact
          path="/blogs"
          element={
            <PrivateUserRoute>
              <BlogPage />
            </PrivateUserRoute>
          }
        />
        <Route
          exact
          path="/press"
          element={
            <PrivateUserRoute>
              <PressPage />
            </PrivateUserRoute>
          }
        />
        <Route
          exact
          path="/settings"
          element={
            <PrivateUserRoute>
              <Settings />
            </PrivateUserRoute>
          }
        />
      </Routes>
    </Router>
  );
};
